import React, { FC } from 'react';
import { Image } from '../Image';
import styles from './ReportCard.module.scss';

interface Props {
  reportCardData: { [key: string]: string };
}
const ReportCard: FC<Props> = (props) => {
  const { reportCardData } = props;
  const { coverImg, title, date, downBtnURL } = reportCardData;
  return (
    <>
      <div className={styles['Report-card-box']}>
        <a href={downBtnURL} target="_blank" rel="noreferrer">
          <div className={styles['report-img-wrap']}>
            <Image src={coverImg} width={500} height={679} layout="responsive" />
          </div>
          <div className={styles['report-info-box']}>
            <div className={styles['report-title']}>{title}</div>
            <p className={styles['report-date']}>{date}</p>
          </div>
        </a>
      </div>
    </>
  );
};

ReportCard.displayName = 'ReportCard';
export default ReportCard;
